import Vue from "vue";
import App from "./App.vue";
import "./assets/css/reset.css"; /*引入公共样式*/
import "./assets/css/publice.css"; /*引入公共样式*/
import "./assets/css/iconfont.css";
// 引入rem.js
import "./utils/rem";

import "animate.css"; // 引入animate.css
import WOW from "wow.js"; // 引入wow.js

// 引入vant
import "./lib/element";
import "element-ui/lib/theme-chalk/index.css";

// 引入路由
import router from "./router/index";

// 引入 vuex文件
import store from "./store/index";

// 引入i18n配置
import i18n from "./lang/index";

// 引入less
// import less from 'less'
// Vue.use(less)

Vue.config.productionTip = false;

// 自动获取域名
const currentHost = window.location.host;
const protocol = window.location.protocol;
const baseUrl = `${protocol}//${currentHost}`;

function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent,
  );
}

const currentPath = window.location.pathname;
const search = window.location.search;
const isMob = isMobile();
const isH5Path = currentPath.startsWith("/H5");

if (isMob && !isH5Path) {
  window.location.replace(`${baseUrl}/H5${currentPath}${search}`);
} else if (!isMob && isH5Path) {
  const realPath = currentPath.replace(/^\/H5/, "");
  window.location.replace(`${baseUrl}${realPath || "/"}${search}`);
} else {
  // 无需重定向，启动 Vue 应用
  new Vue({
    render: (h) => h(App),
    router,
    store,
    i18n, // 添加i18n
    mounted() {
      // 初始化WOW.js
      new WOW().init();
    },
  }).$mount("#app");
}
